import { getOpenid, getOpenIdLogin } from '@/api/index.js'
import * as sysTool from './systemTool'
import Cookies from 'js-cookie'
import { Toast } from 'vant'
import { setUrlList } from './setSharaUrl'
// 获取code
function getCode() {
  let APPID = ''
  // 配置appID
  if (process.env.NODE_ENV === 'production') {
    APPID = 'wxe533f512cde85713'
  } else {
    APPID = 'wxdea1d48bd3bac31e'
  }
  let getUrlParams = (name) => {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    let r = window.location.search.substr(1).match(reg)
    if (r != null) {
      return unescape(r[2])
    }
    return null
  }
  let code = getUrlParams('code')
  let local = window.location.href
  if (code == null || code === '') {
    window.location.href =
      'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
      APPID +
      '&redirect_uri=' +
      encodeURIComponent(local) +
      '&response_type=code&scope=snsapi_base&state=#wechat_redirect'
  }
  return code
}
//  是否在微信环境内
export function isWeiXin() {
  let ua = window.navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}
//获取ua user_agent
export function getUserAgent() {
  var brower = sysTool.GetCurrentBrowser()
  var os = sysTool.GetOs() /* */
  var edition = sysTool.getEdition()
  let user_agent = brower + ' ' + '(' + os + ';' + edition + ')'
  return user_agent
}
function getOpenIdToLogin(openid, data) {
  let params = {
    openid: openid,
    ua: getUserAgent(),
    browser: 2,
  }
  getOpenIdLogin(params)
    .then((response) => {
      if (response.data.code == 200) {
        let mobile = response.data.data.mobile
        let status = response.data.data.status
        let userList = response.data.data.user_list
        Cookies.set('userPhoneInfo', { mobile: mobile }, { expires: 14 })
        Cookies.set('loginStatus', { status: status, openid: openid })
        if (userList && userList.token) {
          Cookies.set('loginInfo', userList)
        }
        data.cb(status)
      } else {
        data.cb()
      }
    })
    .catch((err) => {
      data.cb()
    })
}
export function openIdlogin(data) {
  let code = ''
  code = getCode()
  if (code) {
    let loginStatus = Cookies.get('loginStatus')
      ? JSON.parse(Cookies.get('loginStatus'))
      : ''
    if (loginStatus && loginStatus.openid) {
      getOpenIdToLogin(loginStatus.openid, data)
    } else {
      getOpenid({ code: code })
        .then((res) => {
          if (res.data.code == 200) {
            let openId = res.data.data
            getOpenIdToLogin(openId, data)
          } else {
            Toast(res.data.message)
            data.cb()
          }
        })
        .catch((err) => {
          data.cb()
        })
    }
  }
}
// 通过登录回到相关页面
export function toLoginView(data) {
  let arr = [
    {
      froName: 'Personal',
      type: 1,
    },
    {
      froName: 'agentOperationAfrim',
      type: 2,
    },
    {
      froName: 'PositionDetail',
      type: 3,
    },
    {
      froName: 'actingOperationDaily',
      type: 4,
    },
    {
      froName: 'receivingOrderList',
      type: 5,
    },
    {
      froName: 'Workbench',
      type: 6,
    },
    {
      froName: 'historyBrows',
      type: 7,
    },
    {
      froName: 'collection',
      type: 8,
    },
  ]

  let obj = arr.find((v) => {
    if (data.name) {
      return v.froName == data.name
    } else if (data.path.indexOf(v.froName) > -1) {
      return true
    } else {
      return false
    }
  })
  if (obj) {
    let query = { type: obj.type, ...data.query }
    obj.query = query
  }
  return obj
}

// 回到职位列表
export function toJobList(data, info) {
  let arr = setUrlList()
  let isTo = false
  arr.forEach((item) => {
    if (data.name) {
      if (item == data.name) {
        isTo = true
      }
    } else if (data.path.indexOf(item) > -1) {
      isTo = true
    }
  })
  if (info && isTo) {
    let index = window.location.href.indexOf('num=')
    let userId = ''
    if (index > 0) {
      userId = window.location.href.substr(
        index + 4,
        window.location.href.length - 1
      )
      if (userId == info.member_info.id) {
        isTo = false
      }
    } else {
      isTo = false
    }
  }
  return isTo
}
